import React from "react";
import T from "prop-types";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import SelectLot from "MODULES/Lots/shared/SelectLot/SelectLot";
import SelectLotCode from "MODULES/Lots/shared/SelectLotCode/SelectLotCode";
import { LOT_LINE_ITEM } from "MODULES/Lots/constants";

function LotSection({
  handleLotSelected,
  selectedLot,
  receivingType,
  setFieldValue
}) {
  if (receivingType !== LOT_LINE_ITEM) return null;

  return (
    <FormRow>
      <Col md={3}>
        <SelectLot
          setFieldValue={setFieldValue}
          handleLotSelected={handleLotSelected}
          selectedLot={selectedLot}
        />
      </Col>
      <Col md={3}>
        <SelectLotCode
          setFieldValue={setFieldValue}
          handleLotSelected={handleLotSelected}
          selectedLot={selectedLot}
        />
      </Col>
    </FormRow>
  );
}

LotSection.propTypes = {
  handleLotSelected: T.func,
  receivingType: T.string.isRequired,
  selectedLot: T.shape({}),
  setFieldValue: T.func.isRequired
};

export default LotSection;



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Create/FormSections/LotSection.jsx